import { SearchDeliveriesRes_Result } from "gen/search/service/service_pb"

import { deliveryMapping } from "./delivery.adapter"
import {
  BaseDelivery,
  BaseDeliveryStop,
  StopTransaction,
} from "./delivery.type"
import { mapFields } from "../adapters"
import { Money } from "../classes/money"

export interface DeliveryListRow
  extends Omit<BaseDelivery, "dispatchLocation"> {
  dispatchLocation: NonNullable<BaseDelivery["dispatchLocation"]>
  transactions: StopTransaction[]
  numItems: number
  total: Money
}

export function adaptDeliveryListRows(
  results: SearchDeliveriesRes_Result[]
): DeliveryListRow[] {
  const rows: DeliveryListRow[] = []

  for (const result of results) {
    const { data: delivery, errors } = mapFields(result, deliveryMapping)
    if (errors || !delivery.dispatchLocation) {
      continue
    }

    // Cancelled stops stay in the row for display, but only live stops count toward the roll-ups.
    const liveTransactions = uniqueTransactions(
      delivery.stops.filter((stop) => stop.status !== "Cancelled")
    )
    rows.push({
      ...delivery,
      dispatchLocation: delivery.dispatchLocation,
      transactions: uniqueTransactions(delivery.stops),
      numItems: liveTransactions.reduce(
        (total, transaction) => total + transaction.numItems,
        0
      ),
      total: liveTransactions.reduce(
        (total, transaction) => total.add(transaction.total),
        Money.zero()
      ),
    })
  }

  return rows
}

// A sale can sit on several stops of one delivery, so the roll-ups dedupe by id.
function uniqueTransactions(stops: BaseDeliveryStop[]): StopTransaction[] {
  const seen = new Set<string>()
  const result: StopTransaction[] = []
  for (const stop of stops) {
    for (const transaction of stop.transactions) {
      const id = transaction.id.toString()
      if (seen.has(id)) {
        continue
      }
      seen.add(id)
      result.push(transaction)
    }
  }

  return result
}
